/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voices_Open_Manager_Aria_LabelInputs */

const en_voices_open_manager_aria_label = /** @type {(inputs: Voices_Open_Manager_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open voice manager`)
};

const fr_voices_open_manager_aria_label = /** @type {(inputs: Voices_Open_Manager_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir le gestionnaire de voix`)
};

const de_voices_open_manager_aria_label = /** @type {(inputs: Voices_Open_Manager_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Voice Manager`)
};

const it_voices_open_manager_aria_label = /** @type {(inputs: Voices_Open_Manager_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apri il gestore vocale`)
};

const ru_voices_open_manager_aria_label = /** @type {(inputs: Voices_Open_Manager_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Открытый голосовой менеджер`)
};

const es_voices_open_manager_aria_label = /** @type {(inputs: Voices_Open_Manager_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrador de voz abierto`)
};

const zh_cn2_voices_open_manager_aria_label = /** @type {(inputs: Voices_Open_Manager_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开放式语音管理器`)
};

const ja_voices_open_manager_aria_label = /** @type {(inputs: Voices_Open_Manager_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オープンボイスマネージャー`)
};

const hi_voices_open_manager_aria_label = /** @type {(inputs: Voices_Open_Manager_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ओपन वॉइस मैनेजर`)
};

const pt_pt2_voices_open_manager_aria_label = /** @type {(inputs: Voices_Open_Manager_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abra o gerenciador de voz`)
};

/**
* | output |
* | --- |
* | "Open voice manager" |
*
* @param {Voices_Open_Manager_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voices_open_manager_aria_label = /** @type {((inputs?: Voices_Open_Manager_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voices_Open_Manager_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_voices_open_manager_aria_label(inputs)
	if (locale === "de") return de_voices_open_manager_aria_label(inputs)
	if (locale === "it") return it_voices_open_manager_aria_label(inputs)
	if (locale === "ru") return ru_voices_open_manager_aria_label(inputs)
	if (locale === "es") return es_voices_open_manager_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_voices_open_manager_aria_label(inputs)
	if (locale === "ja") return ja_voices_open_manager_aria_label(inputs)
	if (locale === "hi") return hi_voices_open_manager_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_voices_open_manager_aria_label(inputs)
	return en_voices_open_manager_aria_label(inputs)
});